// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory-order/tabs/order-review/components/order-receive-scan/order-receive-scan.less
// module id = 3579
// module chunks = 0